import React from 'react';
import { Tooltip, Zoom } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ palette }: any) => ({
  launcher: {
    cursor: 'auto',
    marginLeft: '.3rem',
  },
  tooltipIcon: {
    width: 15,
    height: 15,
    marginLeft: 2,
    marginBottom: -3,
  },
  container: {
    border: `1px solid  ${palette.common.cowbellBlue}`,
    backgroundColor: palette.background.default,
    color: palette.text.primary,
    borderRadius: 5,
    padding: '1rem',
    marginBottom: 5,
    fontSize: '0.875rem',
    display: 'flex',
    flexDirection: 'column',
  },
}));

interface DescTooltipProps {
  readonly tooltip?: React.ReactNode;
  // `title` is not consumed by this component (the tooltip text comes from
  // `tooltip`); it is accepted for backwards compatibility with existing call
  // sites that pass it, matching the previously untyped behaviour.
  readonly title?: React.ReactNode;
  readonly style?: React.CSSProperties;
  readonly onOpen?: () => void;
  readonly onClose?: () => void;
}

function DescTooltip({
  tooltip,
  style,
  onOpen,
  onClose,
}: Readonly<DescTooltipProps>) {
  const classes = useStyles();

  return (
    <Tooltip
      title={tooltip}
      placement="top"
      arrow
      className={classes.launcher}
      classes={{ tooltip: classes.container }}
      TransitionComponent={Zoom}
      onOpen={onOpen}
      onClose={onClose}
    >
      <img
        src="/images/Tooltip.svg"
        className={classes.tooltipIcon}
        style={style}
        alt="ToolTip"
      />
    </Tooltip>
  );
}

export default DescTooltip;
